import { useTranslation } from "react-i18next";
import { FormField } from "@babackapp/ui/components/form";
import { Input } from "@babackapp/ui/components/input";
import type { ActionNodeReturnOrderAttributeConfigDto } from "@babackapp/private-api-client/types";
import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelContent } from "../../lib/panel/panel-content";
import { ReturnPlaceholdersHint } from "../../components/return-placeholders-hint";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";

function PanelOrderAttribute() {
  const form = useWorkflowForm();
  const { t } = useTranslation("trackoffice");
  const namePath = useNodeFormPath("config.name");
  const valuePath = useNodeFormPath("config.value");

  if (!namePath || !valuePath) {
    return null;
  }

  return (
    <PanelContent
      title={t("workflowsEditor.returnOrderAttribute.title", "Order attribute")}
      description={t(
        "workflowsEditor.returnOrderAttribute.description",
        "Sets a custom attribute on the Shopify order linked to the return.",
      )}
    >
      <div className="flex flex-col gap-2">
        <FormField
          control={form.control}
          name={namePath}
          render={({ field }) => (
            <Input
              value={(field.value as string) ?? ""}
              onChange={field.onChange}
              className="h-8 text-xs"
              placeholder={t(
                "workflowsEditor.returnOrderAttribute.namePlaceholder",
                "Attribute name",
              )}
            />
          )}
        />
        <FormField
          control={form.control}
          name={valuePath}
          render={({ field }) => (
            <Input
              value={(field.value as string) ?? ""}
              onChange={field.onChange}
              className="h-8 text-xs"
              placeholder={t(
                "workflowsEditor.returnOrderAttribute.valuePlaceholder",
                "Value",
              )}
            />
          )}
        />
      </div>
      <ReturnPlaceholdersHint />
    </PanelContent>
  );
}

export function ReturnOrderAttributeActionNodePanel(
  props: NodePanelProps<ActionNodeReturnOrderAttributeConfigDto>,
) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelOrderAttribute />
    </PanelContainer>
  );
}
